<template>
  <div class="profile-progress-details">
    <el-row :gutter="gutter">
      <el-col :span="6" class="left-col">
        <el-progress
          type="circle"
          :percentage="report.progress"
          :status="status"
        />

        <p class="report-label">
          Current profile completion: {{ report.progress }}% ({{ done }} /
          {{ total }})
        </p>
      </el-col>
      <el-col :span="18">
        <div class="sections-progress">
          <el-tabs type="border-card" tab-position="left" stretch>
            <el-tab-pane>
              <div slot="label">
                <el-badge
                  :is-dot="!overviewFieldsCompleted"
                  class="margin-top-5"
                >
                  Overview
                </el-badge>
              </div>
              <ProfileProgressSection
                show-progress-bar
                :fields="overviewFields"
              />
            </el-tab-pane>
            <el-tab-pane>
              <div slot="label">
                <el-badge :is-dot="!teamFieldsCompleted" class="margin-top-5">
                  Team
                </el-badge>
              </div>
              <p v-if="!teamFieldsCompleted">
                Please fill in at least one team member (hint: start with
                yourself).
              </p>
              <p v-else>
                Team member already added. <ion-icon name="checkmark" />
              </p>
            </el-tab-pane>
            <el-tab-pane>
              <div slot="label">
                <el-badge :is-dot="!faqFieldsCompleted" class="margin-top-5">
                  QA
                </el-badge>
              </div>
              <ProfileProgressSection show-progress-bar :fields="faqFields" />
            </el-tab-pane>
            <el-tab-pane>
              <div slot="label">
                <el-badge
                  :is-dot="!documentsFieldsCompleted"
                  class="margin-top-5"
                >
                  Documents
                </el-badge>
              </div>
              <p v-if="!documentsFieldsCompleted">
                Please upload a pitch deck.
              </p>
              <p v-else>
                Pitch deck already uploaded. <ion-icon name="checkmark" />
              </p>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { PROFILE_PROGRESS_THRESHOLD, SECTIONS } from '@/services/startup-report'
import ProfileProgressSection from './ProfileProgressSection.vue'

export default {
  components: {
    ProfileProgressSection,
  },
  props: {
    startup: {},
    report: {
      progress: 0,
    },
  },
  data() {
    return {
      gutter: 10,
    }
  },
  computed: {
    status() {
      if (this.report.progress >= PROFILE_PROGRESS_THRESHOLD) {
        return 'success'
      } else {
        return null
      }
    },
    done() {
      return this.report.fields.filter((f) => f.done).length
    },
    total() {
      return this.report.fields.length
    },
    fields() {
      return this.report.fields
    },
    overviewFields() {
      return this.fields.filter((f) => f.section === SECTIONS.OVERVIEW)
    },
    overviewFieldsCompleted() {
      return this.areAllDone(this.overviewFields)
    },
    teamFields() {
      return this.fields.filter((f) => f.section === SECTIONS.TEAM)
    },
    teamFieldsCompleted() {
      return this.areAllDone(this.teamFields)
    },
    faqFields() {
      return this.fields.filter(
        (f) => f.section === SECTIONS.FAQ && f.name !== 'faq_header',
      )
    },
    faqFieldsCompleted() {
      return this.areAllDone(this.faqFields)
    },
    documentsFields() {
      return this.fields.filter((f) => f.section === SECTIONS.DOCUMENTS)
    },
    documentsFieldsCompleted() {
      return this.areAllDone(this.documentsFields)
    },
  },
  methods: {
    areAllDone(fields) {
      const total = fields.length
      const doneFields = fields.filter((f) => f.done).length
      return total === doneFields
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.profile-progress-details {
  font-size: 14px;
  color: $muted;

  .left-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .report-label {
      padding: 15px 5px;
    }
  }

  .sections-progress {
    .el-badge__content.is-fixed.is-dot {
      top: 10px;
    }

    .el-tabs {
      height: 400px;
      .el-tabs__content {
        height: 410px;
        overflow: auto;
      }
    }
  }
}
</style>
